import * as React from "react";
import {FacebookIcon, FacebookShareButton, TwitterShareButton, XIcon} from "react-share";
import {css} from "@emotion/react";

import {rpCommonUrl} from "../../../app/read_rp_environment_variables";

interface IProps {
    className?: string;
    pathname: string;
    quote: string;
    showLabels?: boolean;
    modalViewPlacement?: boolean;
    iconSize?: number;
}

export const ArticleShareButtons: React.FunctionComponent<IProps> = (props) => {
    const {pathname, quote, showLabels, iconSize = 38, modalViewPlacement} = props;

    const buttonProps = {
        url: rpCommonUrl + pathname,
        quote,
        css: modalViewPlacement ? shareButtonSocialModalView : shareButtonSocial
    };

    const iconProps = {
        size: iconSize,
        borderRadius: 10
    };

    const renderLabel = (type: string): React.ReactNode => {
        if (showLabels) {
            return <span css={label}>Udostępnij na {type}</span>;
        }
        return null;
    };

    return (
        <div css={modalViewPlacement ? shareButtonsModalView : shareButtonsBelowArticle}>
            <FacebookShareButton {...buttonProps}>
                <FacebookIcon {...iconProps} /> {renderLabel("Facebooku")}
            </FacebookShareButton>

            <TwitterShareButton {...buttonProps}>
                <XIcon {...iconProps} /> {renderLabel("X")}
            </TwitterShareButton>
        </div>
    );
};

const shareButtonSocial = css`
    align-self: center;
    margin-bottom: 0;
    margin-left: 2rem;
    &:focus {
        outline: 0;
    }
`;

const shareButtonSocialModalView = css`
    display: flex;
    align-items: center;

    &:focus {
        outline: 0;
    }
`;

const shareButtonsBelowArticle = css`
    display: flex;
    flex-direction: row;
    margin-left: 1rem;
`;

const shareButtonsModalView = css`
    display: flex;
    flex-direction: column;
`;

const label = css`
    margin-left: 2.1rem;
    font-size: 1.4rem;
    line-height: 5;
    font-weight: 400;
`;
